import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Information from './Information';
import Password from './Password';

const SettingsRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Information />} />
      <Route path="/password" element={<Password />} />
    </Routes>
  );
};

export default SettingsRoutes;
